// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/footer-brand-1440.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_dark-container {
  display: flex;
  padding: 2.7%;
  background-color: #000;
}
@media screen and (max-width: 850px) {
  .footer_dark-container {
    padding: 2.7% 1%;
  }
}
@media screen and (max-width: 768px) {
  .footer_dark-container {
    padding: 2.7%;
    flex-direction: column;
    align-items: center;
  }
}
@media screen and (max-width: 415px) {
  .footer_dark-container {
    padding: 25px 2.7%;
  }
}
.footer_white-container {
  padding: 16px 2.7%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (max-width: 415px) {
  .footer_white-container {
    padding: 26px 2.7%;
    justify-content: center;
    flex-direction: column;
    gap: 20px;
  }
}
.footer_white-container span, .footer_white-container a {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0em;
  text-decoration: none;
  color: #000;
}
@media screen and (max-width: 415px) {
  .footer_white-container a {
    text-decoration: underline;
    color: #000;
    order: 1;
  }
}
.footer_brand {
  background: #000 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  height: 48px;
  width: 263px;
  display: inline-block;
  padding: 15px 0px;
}
@media screen and (max-width: 415px) {
  .footer_brand {
    margin-bottom: 20px;
  }
}
.footer_content {
  width: 100%;
  padding: 0px 5%;
}
@media screen and (max-width: 1100px) {
  .footer_content {
    padding: 0 3%;
  }
}
@media screen and (max-width: 1024px) {
  .footer_content {
    padding: 0 2%;
  }
}
@media screen and (max-width: 850px) {
  .footer_content {
    padding: 0 1%;
  }
}
.footer_links {
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-bottom: 20px;
}
@media screen and (max-width: 768px) {
  .footer_links {
    display: none;
  }
}
.footer_links a {
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
}
@media screen and (max-width: 980px) {
  .footer_links a {
    font-size: 14px;
  }
}
@media screen and (max-width: 910px) {
  .footer_links a {
    font-size: 13px;
    width: min-content;
  }
}
@media screen and (max-width: 768px) {
  .footer_text {
    display: flex;
    justify-content: space-evenly;
    margin-top: 25px;
  }
}
@media screen and (max-width: 415px) {
  .footer_text {
    flex-direction: column;
    align-items: center;
    gap: 27px;
    margin-top: 10px;
  }
}
.footer_text span, .footer_text a {
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  letter-spacing: 0em;
  text-decoration: none;
}
.footer_text .download-text {
  width: 20%;
  text-align: center;
}
@media screen and (max-width: 415px) {
  .footer_text .download-text {
    width: 100%;
  }
}
.footer_tel {
  margin: 0px 30px 0px 10px;
}

.flex-md {
  display: inline;
}
@media screen and (max-width: 768px) {
  .flex-md {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
@media screen and (max-width: 415px) {
  .flex-md {
    display: inline;
  }
}

.linkedin {
  margin-left: 7px;
  width: 24px;
  height: 24px;
}

@media screen and (max-width: 415px) {
  .hidden-sm {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Footer.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,aAAA;EACA,sBAAA;AAAR;AACQ;EAJJ;IAKQ,gBAAA;EAEV;AACF;AADQ;EAPJ;IAQQ,aAAA;IACA,sBAAA;IACA,mBAAA;EAIV;AACF;AAHQ;EAZJ;IAaQ,kBAAA;EAMV;AACF;AAJI;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAMR;AALQ;EALJ;IAMQ,kBAAA;IACA,uBAAA;IACA,sBAAA;IACA,SAAA;EAQV;AACF;AAPQ;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;AASZ;AANY;EADJ;IAEQ,0BAAA;IACA,WAAA;IACA,QAAA;EASd;AACF;AAJI;EACI,yEAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;AAMR;AALQ;EANJ;IAOQ,mBAAA;EAQV;AACF;AANI;EACI,WAAA;EACA,eAAA;AAQR;AAPQ;EAHJ;IAIQ,aAAA;EAUV;AACF;AATQ;EANJ;IAOQ,aAAA;EAYV;AACF;AAXQ;EATJ;IAUQ,aAAA;EAcV;AACF;AAZI;EACI,WAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,oBAAA;AAcR;AAbQ;EANJ;IAOQ,aAAA;EAgBV;AACF;AAdQ;EACI,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAgBZ;AAfY;EAPJ;IAQQ,eAAA;EAkBd;AACF;AAjBY;EAVJ;IAWQ,eAAA;IACA,kBAAA;EAoBd;AACF;AAhBQ;EADJ;IAEQ,aAAA;IACA,6BAAA;IACA,gBAAA;EAmBV;AACF;AAlBQ;EANJ;IAOQ,sBAAA;IACA,mBAAA;IACA,SAAA;IACA,gBAAA;EAqBV;AACF;AAnBQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AAqBZ;AAnBQ;EACI,UAAA;EACA,kBAAA;AAqBZ;AApBY;EAHJ;IAIQ,WAAA;EAuBd;AACF;AApBI;EACI,yBAAA;AAsBR;;AAnBA;EACI,eAAA;AAsBJ;AArBI;EAFJ;IAGQ,aAAA;IACA,sBAAA;IACA,mBAAA;EAwBN;AACF;AAvBI;EAPJ;IAQQ,eAAA;EA0BN;AACF;;AAxBA;EACI,gBAAA;EACA,WAAA;EACA,YAAA;AA2BJ;;AAxBA;EACI;IACI,aAAA;EA2BN;AACF","sourcesContent":[".footer {\n    &_dark-container {\n        display: flex;\n        padding: 2.7%;\n        background-color: #000;\n        @media screen and (max-width: 850px) {\n            padding: 2.7% 1%;\n        }\n        @media screen and (max-width: 768px) {\n            padding: 2.7%;\n            flex-direction: column;\n            align-items: center;\n        }\n        @media screen and (max-width: 415px) {\n            padding: 25px 2.7%;\n        }\n    }\n    &_white-container {\n        padding: 16px 2.7%;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        @media screen and (max-width: 415px) {\n            padding: 26px 2.7%;\n            justify-content: center;\n            flex-direction: column;\n            gap: 20px;\n        }\n        span, a {\n            font-size: 12px;\n            line-height: 16px;\n            letter-spacing: 0em;\n            text-decoration: none;\n            color: #000;\n        }\n        a {\n            @media screen and (max-width: 415px) {\n                text-decoration: underline;\n                color: #000;\n                order: 1;\n                \n            }\n        }\n\n    }\n    &_brand {\n        background: #000 url(\"../../assets/images/footer-brand-1440.png\")  no-repeat center;\n        height: 48px;\n        width: 263px;\n        display: inline-block;\n        padding: 15px 0px;\n        @media screen and (max-width: 415px) {\n            margin-bottom: 20px;\n        }\n    }\n    &_content {\n        width: 100%;\n        padding: 0px 5%;\n        @media screen and (max-width: 1100px) {\n            padding: 0 3%;\n        }\n        @media screen and (max-width: 1024px) {\n            padding: 0 2%;\n        }\n        @media screen and (max-width: 850px) {\n            padding: 0 1%;\n        }\n    }\n    &_links {\n        color: #fff;\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n        padding-bottom: 20px;\n        @media screen and (max-width: 768px) {\n            display: none;\n        }\n        \n        a {\n            color: #fff;\n            text-decoration: none;\n            font-size: 16px;\n            font-weight: 500;\n            line-height: 26px;\n            letter-spacing: 0em;\n            @media  screen and (max-width: 980px) {\n                font-size: 14px;\n            }\n            @media  screen and (max-width: 910px) {\n                font-size: 13px;\n                width: min-content;\n            }\n        }\n    }\n    &_text {\n        @media screen and (max-width: 768px) {\n            display: flex;\n            justify-content: space-evenly;\n            margin-top: 25px;\n        }\n        @media screen and (max-width: 415px) {\n            flex-direction: column;\n            align-items: center;\n            gap: 27px;\n            margin-top: 10px;\n        }\n          \n        span, a {\n            font-size: 16px;\n            font-weight: 500;\n            line-height: 26px;\n            letter-spacing: 0em;\n            text-decoration: none;\n        }\n        .download-text {\n            width: 20%;\n            text-align: center;\n            @media screen and (max-width: 415px) {\n                width: 100%;\n            }\n        }\n    }\n    &_tel {\n        margin: 0px 30px 0px 10px;\n    }\n}\n.flex-md {\n    display: inline;\n    @media screen and (max-width: 768px) {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    @media screen and (max-width: 415px) {\n        display: inline;\n    }\n}\n.linkedin {\n    margin-left: 7px;\n    width: 24px;\n    height: 24px;\n}\n\n@media screen and (max-width: 415px) {\n    .hidden-sm {\n        display: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
